import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-datos">
            <div className= "titulo-datos">
                <h2>
                    Actualiza tus Datos
                </h2>
            </div>
        </div>      
    );
};

export default Header;